module.exports = __webpack_public_path__ + "img/payment_pc_08.f271b3f2.png";